import SendMessageAero from "../../assets/images/SendMessageAero.svg";
import QuestImage from "../../assets/images/helphubImg.png";

import HelpHubHomeEmoji1 from "../../assets/images/HelpHubHomeEmoji1.svg";
import HelpHubHomeEmoji2 from "../../assets/images/HelpHubHomeEmoji2.svg";
import HelpHubHomeEmoji3 from "../../assets/images/HelpHubHomeEmoji3.svg";
import HelpHubHomeEmoji4 from "../../assets/images/HelpHubHomeEmoji4.svg";
import HelpHubHomeEmoji5 from "../../assets/images/HelpHubHomeEmoji5.svg";
import OpenSectionButton from "../../assets/images/OpenSectionButton.svg";
import CustomerService from "../../assets/images/CustomerService.svg";
import { HelpHubHomeTypes, QuestCriteriaWithStatusType } from "./CustomHelpHub.type";
import { useContext, useEffect, useState } from "react";
import QuestContext from "../QuestWrapper";
import config from "../../config";
import { claimQuest } from "./CustomHelphub.service";
import { getColorVariations, hexToGlassColor } from "./components/helperfunction";
import { extractGradientColors } from "../../general";

const CustomHelpHubHome = (props: HelpHubHomeTypes) => {
  const {
    questsData,
    setSelectedSection,
    parentQuest,
    userId,
    token,
    styleConfig,
    contentConfig,
    taskStatus,
    onlineComponent,
    showFeedback = true,
    setShowFeedback,
    entityImage,
    uniqueUserId,
    uniqueEmailId,
    entityAuthenticationToken,
    BrandTheme,
    QuestThemeData,
    contentData,
    position,
    setPositionInLocal,
    setHelpHub,
    isActive,
    onClose,
    sectionConfig,
  } = props;

  const [allQuestsData, setAllQuestsData] = useState<
    QuestCriteriaWithStatusType[][]
  >([]);
  const { apiKey, entityId, apiType, themeConfig } = useContext(
    QuestContext.Context
  );
  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;
  // let [showFeedback, setShowFeedback] = useState<boolean>(false);
  let [feedbackLoading, setFeedbackLoading] = useState<boolean>(false);
  useEffect(() => {
    setAllQuestsData(questsData);
    let arr =
      (!!questsData?.length &&
        questsData[3]
          ?.filter((ele: QuestCriteriaWithStatusType) => ele.completed === true)
          .map((ele: QuestCriteriaWithStatusType) => ele.criteriaId)) ||
      [];
    // setTaskStatus(
    //     Math.ceil(
    //         100 *
    //             (arr?.length /
    //                 (!!questsData?.length ? questsData[3]?.length : 0))
    //     ) || 0
    // );
    if (onlineComponent) {
      if (setShowFeedback)
        setShowFeedback(
          !!questsData?.length &&
          !!questsData[0][0] &&
          questsData[0][0]?.completed == false
        );
    } else {
      if (setShowFeedback) setShowFeedback(showFeedback);
    }
  }, [questsData]);

  const submitQuest = async (answer: number) => {
    setFeedbackLoading(true);
    if (onlineComponent) {
      let claimResponse = await claimQuest(
        BACKEND_URL,
        entityId,
        parentQuest?.childCampaignActions[0].campaignId || "",
        userId || "",
        token || "",
        apiKey,
        allQuestsData[0][0]?.criteriaId,
        parentQuest?.childCampaignActions[0].campaignVariationId,
        [answer],
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );
      setFeedbackLoading(false);
      if (claimResponse?.success) {
        setShowFeedback && setShowFeedback(false);
      }
    } else {
      setShowFeedback && setShowFeedback(false);
    }
  };

  const cleanTiptapHTML = (html = "") => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll('[data-node-view-wrapper]').forEach((el) => {
      el.replaceWith(...el.childNodes);
    });

    doc.querySelectorAll('[data-drag-handle]').forEach((el) => el.remove());

    doc.querySelectorAll('[draggable]').forEach((el) =>
      el.removeAttribute('draggable')
    );

    return doc.body.innerHTML;
  };

  return (
    <div
      className={"helpHubMainInnerCont animatedDissolve"}
    >
      {/* upper div: div 1 */}
      <div
        className={"custom-MainImgCont"}
      >
        <div className={"custom-home-header"}>
          <div className={"custom-QuestWhiteLogoCont"}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
              <path d="M10.0078 6.88511V8.08943H11.2127L17.9992 1.30589V0.101562H16.7943L10.0078 6.88511Z" fill="#10F48B" />
              <path d="M7.96677 11.3059V10.1016H6.76192L0 16.8851V18.0894H1.18026L7.96677 11.3059Z" fill="#10F48B" />
              <path d="M14.7509 0.101562H12.3412L8.99712 3.46876L5.62845 0.101562H3.21875L8.99712 5.87741L14.7509 0.101562Z" fill="#10F48B" />
              <path d="M14.6285 9.10283L17.9971 5.73564V3.35156L12.2188 9.10283L17.9725 14.8787V12.47L14.6285 9.10283Z" fill="#10F48B" />
              <path d="M11.2127 10.1016H10.0078V11.3059L16.7943 18.0894H17.9746V16.8851L11.2127 10.1016Z" fill="#10F48B" />
              <path d="M7.96677 8.08943V6.88511L1.18026 0.101562H0V1.30589L6.76192 8.08943H7.96677Z" fill="#10F48B" />
              <path d="M0 12.47V14.8787L5.75378 9.10283L0 3.35156V5.73564L3.34408 9.10283L0 12.47Z" fill="#10F48B" />
              <path d="M3.21875 18.095H5.62845L8.99712 14.7278L12.3412 18.095H14.7509L8.99712 12.3438L3.21875 18.095Z" fill="#10F48B" />
            </svg>
          </div>

          {(position === "SIDEBAR" || window.innerWidth <= 450) && <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <div className="q-custom-helphub-close-cont" onClick={() => { setHelpHub && setHelpHub(false); isActive && isActive(false); onClose && onClose(false); }}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.63086 10.3692L6.00003 6.00003L10.3692 10.3692M10.3692 1.63086L5.99919 6.00003L1.63086 1.63086" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>}
        </div>

        <div className={"helpHubTextCont"}>
          <div
            className={"custom-helpHubHelloHead"}
          >
            Hello there 👋🏻
          </div>
          <div
            className={"custom-helpHubHelpHead"}
          >
            How can we help?
          </div>
        </div>
      </div>

      {/* lower div : div 2 */}
      <div className="q-custom-helphub-InnerCont">
        {sectionConfig?.Chat && <div
          className={"custom-SendMessageCont"}
        >
          <div
            className={"CustomCustomerServiceInnerCont"}
          >
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <path opacity="0.4" d="M11.334 6.10221C11.334 8.68221 9.09398 10.7689 6.33398 10.7689L5.71399 11.5155L5.34732 11.9556C5.03399 12.3289 4.43398 12.2489 4.22732 11.8022L3.33398 9.83553C2.12065 8.9822 1.33398 7.62888 1.33398 6.10221C1.33398 3.52221 3.57398 1.43555 6.33398 1.43555C8.34732 1.43555 10.0873 2.54888 10.8673 4.14888C11.1673 4.74222 11.334 5.40221 11.334 6.10221Z" fill="#00CA8D" />
                <path d="M14.6662 8.67509C14.6662 10.2018 13.8796 11.5551 12.6662 12.4084L11.7729 14.3751C11.5662 14.8217 10.9662 14.9084 10.6529 14.5284L9.66622 13.3418C8.05289 13.3418 6.61289 12.6284 5.71289 11.5151L6.33289 10.7684C9.09289 10.7684 11.3329 8.68177 11.3329 6.10177C11.3329 5.40177 11.1662 4.74177 10.8662 4.14844C13.0462 4.64844 14.6662 6.48842 14.6662 8.67509Z" fill="#00CA8D" />
                <path d="M7.99935 6.60156H4.66602C4.39268 6.60156 4.16602 6.3749 4.16602 6.10156C4.16602 5.82823 4.39268 5.60156 4.66602 5.60156H7.99935C8.27268 5.60156 8.49935 5.82823 8.49935 6.10156C8.49935 6.3749 8.27268 6.60156 7.99935 6.60156Z" fill="#00CA8D" />
              </svg>
            </div>
            <p>
              Customer Service
            </p>
          </div>

          <div className={"CustomCustomerServiceSendMessageTextCont"}>
            <p
              className={"CustomerServiceHead"}
            >
              Send us a message
            </p>
            <p
              className={"CustomerServiceDesc"}
            >
              Currently replying under a min
            </p>
          </div>

          <div
            className={"CustomSendMessageButton"}
            onClick={() => setSelectedSection("Chat")}
          >
            <p
            >
              Message Now
            </p>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <path d="M14.4582 8.81672C14.7292 8.68121 14.9004 8.4042 14.9004 8.10118C14.9004 7.79816 14.7292 7.52115 14.4582 7.38564L3.25816 1.78564C2.9744 1.64376 2.63361 1.68296 2.38948 1.88557C2.14535 2.08818 2.04401 2.41591 2.13117 2.72096L3.27403 6.72095C3.37215 7.06439 3.68606 7.30117 4.04324 7.30117L7.70039 7.30117C8.14222 7.30117 8.50039 7.65934 8.50039 8.10117C8.50039 8.543 8.14222 8.90117 7.70039 8.90117H4.04325C3.68606 8.90117 3.37216 9.13795 3.27403 9.48139L2.13117 13.4814C2.04401 13.7864 2.14535 14.1142 2.38948 14.3168C2.63361 14.5194 2.9744 14.5586 3.25816 14.4167L14.4582 8.81672Z" fill="black" />
            </svg>
          </div>
        </div>}

        {/* search for help  */}
        {sectionConfig?.FAQs && <div
          className="q-custom-helhub-search-community"
        >
          <div
            className="search-input"
            onClick={() => setSelectedSection("Help")}
          >
            <div className="q-custom-helphub-search-input-cont">
              <input
                className="q-custom-helphub-search-input"
                placeholder="Search for help..."
              />
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <g clip-path="url(#clip0_3321_76739)">
                  <circle cx="7.66732" cy="7.76888" r="6.33333" stroke="#9CA3AF" stroke-width="0.917045" />
                  <path d="M13.332 13.4336L14.6654 14.7669" stroke="#9CA3AF" stroke-width="0.917045" stroke-linecap="round" />
                </g>
                <defs>
                  <clipPath id="clip0_3321_76739">
                    <rect width="16" height="16" fill="white" transform="translate(0 0.101562)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div className="q-custom-helphub-search-messege">
            {!!allQuestsData?.length &&
              allQuestsData[1]?.map(
                (value: QuestCriteriaWithStatusType, index: number) => (
                  <div
                    className="q-custom-helphub-search-messege-cont"
                    key={index}
                    onClick={() => setSelectedSection("Help")}
                    style={{
                      borderBottom:
                        allQuestsData[1]?.length - 1 == index
                          ? "none"
                          : "1px solid var(--Neutral-White-300, #efefef)",
                    }}
                  >
                    <div
                      className="q-custom-helphub-search-messege-title"
                    >
                      {value?.question}
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.67461 3.05593C5.88428 2.87622 6.19993 2.9005 6.37964 3.11016L10.3796 7.77683C10.5401 7.96407 10.5401 8.24037 10.3796 8.42762L6.37964 13.0943C6.19993 13.3039 5.88428 13.3282 5.67461 13.1485C5.46495 12.9688 5.44067 12.6532 5.62038 12.4435L9.34147 8.10222L5.62038 3.76095C5.44067 3.55129 5.46495 3.23564 5.67461 3.05593Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.6" stroke-linecap="round" />
                    </svg>
                  </div>
                )
              )}
          </div>
        </div>}

        {/* get  updates */}
        {sectionConfig?.Updates && <div className="q-helphub-update-mainCont">
          <div
            className="q-custom-helphub-search-updates"
          >
            <div
              className="q-custom-helphub-updates-innercont"
              onClick={() => setSelectedSection("Updates")}
            >
              <div
                className="q-custom-helphub-quest-community-desc"
              >
                <p>
                  Get Updates
                </p>
              </div>
              <div className="q-custom-helphub-updates-desc">
                {!!allQuestsData?.length &&
                  allQuestsData[2]?.map(
                    (value: QuestCriteriaWithStatusType, index: number) =>
                      index < 2 && (
                        <div
                          className={`q-custom-helphub-updates-innerCont${index + 1}`}
                          key={index}
                        >
                          <div
                          >
                            {value?.linkTitle}
                          </div>
                          <div
                            dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(value?.description) }}
                          />
                        </div>
                      )
                  )}
              </div>
            </div>
            <button
              className="q-custom-helphub-updates-button"
              onClick={() => setSelectedSection("Updates")}
            >
              See all updates
            </button>
          </div>
        </div>}

        {/* review  */}
        <div
          className={`q-custom-helphub-review ${showFeedback && "q-show-feedback"}`}
        >
          <div className="q-custom-helphub-review-text-emoji-cont">
            <div className="q-helphub-review-text-con">
              <div
                className="q-custom-helphub-review-text-head"
              >
                How satisfied are you?
              </div>

              <div
                className="q-custom-helphub-review-text-para"
              >
                How would you rate this journey after using the product after so long?
              </div>
            </div>

            <div className="q-helphub-review-emoji-caption-con">
              <div className="q-custom-helphub-review-emoji-cont">
                {[
                  HelpHubHomeEmoji1,
                  HelpHubHomeEmoji2,
                  HelpHubHomeEmoji3,
                  HelpHubHomeEmoji4,
                  HelpHubHomeEmoji5,
                ].map((e, i) => (
                  <img
                    src={e}
                    alt=""
                    key={i}
                    onClick={() => submitQuest(i + 1)}
                  />
                ))}
              </div>
              <div className="q-custom-helphub-review-emoji-caption">
                <div
                >
                  Not satisfied
                </div>
                <div
                >
                  Very satisfied
                </div>
              </div>
            </div>
          </div>
          {feedbackLoading && (
            <div className="q-helphub-review-loader-con">
              <div className="q-helphub-review-loader"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomHelpHubHome;
